export default "__VITE_ASSET__sBfX1c3D__"